import { useSyncExternalStore } from "react";
import { theme } from "../utils/theme";

const subscribeToResize = (onResize: () => void) => {
  window.addEventListener("resize", onResize);

  return () => window.removeEventListener("resize", onResize);
};

const isDesktopWidth = () => window.innerWidth >= theme.breakpoints.values.md;

const isDesktopOnServer = () => false;

export const useIsDesktopLayout = () =>
  useSyncExternalStore(subscribeToResize, isDesktopWidth, isDesktopOnServer);
